define(['Translator'], function(Translator) {
    Translator.fromJSON(ONP.translations);

    return Translator;
});
